import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const IncompleteInformationApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Incomplete Information Applications(TIFC)"
        status={[applicationStatusMap?.incompleteInformation]}
        stage={null}
      />
    </DashboardLayout>
  );
};

export default IncompleteInformationApplications;
